import React from 'react';
import './VitaminCGainzLogo.css';

const VitaminCGainzLogo = ({ className = '' }) => {
  return (
    <div className={`vcg-logo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img src="/logo.jpg" alt="Vitamin C Gainz" className="vcg-logo-icon" style={{ width: '28px', height: '28px', borderRadius: '8px', objectFit: 'cover' }} />
      <div className="vcg-logo-text">
        <span className="word-vitamin">Vitamin</span>
        <span className="word-c">
          <span className="c-text">C</span>
          <span className="c-glow"></span>
        </span>
        <span className="word-gainz">
          <span className="gainz-text">Gainz</span>
          <span className="gainz-glow"></span>
        </span>
      </div>
      <div className="vcg-tagline">.io</div>
    </div>
  );
};

export default VitaminCGainzLogo;
